// extracted by mini-css-extract-plugin
module.exports = {"rhythm":"28px","halfRhythm":"14px","container":"Layout-module--container--9gWX_","content":"Layout-module--content--nwbxQ","footer":"Layout-module--footer--1ULzl"};